export type BrandMarkProps = {
  alt?: string;
  className?: string;
  variant?: 'symbol' | 'horizontal';
};

export function BrandMark({
  alt = '한국오션플랫폼',
  className,
  variant = 'symbol',
}: BrandMarkProps = {}) {
  const source =
    variant === 'horizontal' ? '/brand/kop-main-horizontal.png' : '/brand/kop-symbol.png';
  const classes = ['kop-brand-mark', `kop-brand-mark--${variant}`, className]
    .filter(Boolean)
    .join(' ');

  return <img className={classes} src={source} alt={alt} decoding="async" />;
}
